// extracted by mini-css-extract-plugin
export var fastFactStacked = "fast-fact-stacked-module--fast-fact-stacked--90aad";
export var fastFactStacked__body = "fast-fact-stacked-module--fast-fact-stacked__body--c2360";
export var fastFactStacked__eyebrow = "fast-fact-stacked-module--fast-fact-stacked__eyebrow--c62b2";
export var fastFactStacked__headline = "fast-fact-stacked-module--fast-fact-stacked__headline--f1dcf";
export var fastFactStacked__trailing = "fast-fact-stacked-module--fast-fact-stacked__trailing--52616";
export var mt0 = "fast-fact-stacked-module--mt-0--7d24d";
export var mt1 = "fast-fact-stacked-module--mt-1--d3379";
export var mt2 = "fast-fact-stacked-module--mt-2--0904f";
export var mt3 = "fast-fact-stacked-module--mt-3--883f6";
export var mt4 = "fast-fact-stacked-module--mt-4--35c3c";
export var mt5 = "fast-fact-stacked-module--mt-5--4e783";
export var mt6 = "fast-fact-stacked-module--mt-6--9474d";